import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    dropzone: {
        marginTop: theme.spacing(3),
    },
    parseErrorAlert: {
        marginTop: theme.spacing(2),
    },
    previewContainer: {
        marginTop: theme.spacing(2),
    },
    commandsFound: {
        marginTop: theme.spacing(2),
    },
    noImportableAlert: {
        marginTop: theme.spacing(1),
    },
    previewList: {
        maxHeight: 300,
        overflowY: "auto",
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: 4,
        marginTop: theme.spacing(1),
    },
    statusIconWrapper: {
        minWidth: 0,
    },
    statusIconError: {
        color: theme.palette.emteria.error,
    },
    statusIconWarning: {
        color: theme.palette.emteria.warning,
    },
    statusIconSuccess: {
        color: theme.palette.emteria.success,
    },
}));
